document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('shop-by-video-modal');
  if (!modal) return;

  const modalContent = modal.querySelector('.shop-by-video__modal-content');
  const thumbButtons = document.querySelectorAll('.shop-by-video__thumb-btn');
  const closeEls = modal.querySelectorAll('[data-modal-close]');

  // --- Carousel arrow controls ---
  document.querySelectorAll('.shop-by-video__carousel').forEach(function (carousel) {
    const track = carousel.querySelector('.shop-by-video__grid');
    const prevBtn = carousel.querySelector('.shop-by-video__nav--prev');
    const nextBtn = carousel.querySelector('.shop-by-video__nav--next');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollByOneItem(direction) {
      const item = track.querySelector('.shop-by-video__item');
      const itemWidth = item ? item.getBoundingClientRect().width + 19.2 : track.clientWidth * 0.5; // 19.2px ~= 1.2rem gap
      track.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });
    }

    function updateNavState() {
      const maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () { scrollByOneItem(-1); });
    nextBtn.addEventListener('click', function () { scrollByOneItem(1); });
    track.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    updateNavState();
  });

  function openModal(blockId) {
    const template = document.getElementById('shop-by-video-data-' + blockId);
    if (!template) return;

    modalContent.innerHTML = '';
    modalContent.appendChild(template.content.cloneNode(true));

    modal.hidden = false;
    document.body.classList.add('shop-by-video-lock-scroll');

    // wire up add-to-cart buttons inside the freshly injected content
    modalContent.querySelectorAll('.shop-by-video__add-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          console.error('Shop by video: missing variant id on Add to cart button');
          return;
        }
        addToCart(variantId, btn);
      });
    });

    // wire up buy-now buttons: add to cart, then redirect straight to checkout
    modalContent.querySelectorAll('.shop-by-video__buy-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          console.error('Shop by video: missing variant id on Buy now button');
          return;
        }
        buyNow(variantId, btn);
      });
    });
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('shop-by-video-lock-scroll');
    const video = modalContent.querySelector('video');
    if (video) video.pause();
    modalContent.innerHTML = '';
  }

  // Resolve the cart root reliably — window.Shopify.routes.root isn't always
  // defined this early in every theme, so fall back to '/'.
  function cartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function postAddToCart(variantId) {
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          // Shopify returns { status, message, description } on failure
          const message = (data && (data.description || data.message)) || 'Add to cart failed';
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function addToCart(variantId, btn) {
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    postAddToCart(variantId)
      .then(function () {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        // Dawn's cart drawer listens for this event on the cart icon bubble;
        // also nudge the theme's own cart update event in case it's listening.
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function (err) {
        console.error('Shop by video — add to cart error:', err.message);
        btn.textContent = 'Error — retry';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      });
  }

  function buyNow(variantId, btn) {
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Redirecting...';

    postAddToCart(variantId)
      .then(function () {
        window.location.href = cartRoot() + 'checkout';
      })
      .catch(function (err) {
        console.error('Shop by video — buy now error:', err.message);
        btn.textContent = 'Error — retry';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      });
  }

  thumbButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.shop-by-video__item');
      const blockId = item.getAttribute('data-video-id');
      openModal(blockId);
    });
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
});
